import React, { useState, useEffect } from "react";
import "./Layouts.css";
import { FaBars, FaChevronDown, FaPhoneAlt, FaTimes } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { Modal, Button } from "react-bootstrap";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import Axios from "../../../axios/axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toTitleCase } from "../../utils/StringUtil";

const TopNavBar = () => {
  const [openMenu, setOpenMenu] = useState(false);
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState(null);

  const [productType, setProductType] = useState(
    sessionStorage.getItem("businessType") || ""
  );
  const [searchKeyword, setSearchKeyword] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");
  const [cartTotal, setCartTotal] = useState(0);
  const [excelModalOpen, setExcelModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadLoading, setUploadLoading] = useState(false);
  const [uploadResponse, setUploadResponse] = useState(null);
  const [uploadError, setUploadError] = useState(null);
  const [confirmModal, setConfirmModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(null);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [supplierInfo, setSupplierInfo] = useState(null);
  const [customerBalance, setCustomerBalance] = useState(null);
  const referenceExcelLink =
    productType === "Rental"
      ? "/excel/RentalOrderCreateExcelFormat.xlsx" // rental-specific reference Excel
      : "/excel/OrderCreateExcelFormat.xlsx"; // common reference Excel for others

  useEffect(() => {
    const fetchCartTotal = async () => {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const customerId = userInfo?.customerId;

      if (!customerId) return;

      try {
        const res = await Axios.get(`/cart/${customerId}`);
        const businessType = sessionStorage.getItem("businessType");

        const filteredItems =
          res.data?.items?.filter((item) =>
            item.productType.includes(businessType)
          ) || [];
        const total = filteredItems.reduce(
          (sum, item) => sum + item.totalItemPrice,
          0
        );
        setCartTotal(total);
      } catch (error) {
        console.error("Error fetching cart total in header:", error);
      }
    };

    fetchCartTotal();
  }, []);

  useEffect(() => {
    const supplierInfoString = sessionStorage.getItem("supplierInfo");
    if (supplierInfoString) {
      const parsed = JSON.parse(supplierInfoString);
      setSupplierInfo(parsed);
    }
  }, []);

  useEffect(() => {
    LoginData();
  }, []);

  useEffect(() => {
    const storedProductType = sessionStorage.getItem("businessType");
    if (storedProductType) {
      setProductType(storedProductType);
    }
  }, []);

  console.log("searchResults", searchResults);

  useEffect(() => {
    const fetchCustomerBalance = async () => {
      const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
      const customerId = userInfo?.customerId;
      if (!customerId) return;

      try {
        const res = await Axios.get(`/customer/get/${customerId}`);
        setCustomerBalance(parseFloat(res.data?.balance || 0));
      } catch (error) {
        console.error("Error fetching customer balance:", error);
      }
    };

    fetchCustomerBalance();
  }, []);

  // const handleSearch = async (e) => {
  //   e.preventDefault();
  //   setError('');
  //   setSearchResults([]);

  //   if (!productType || !searchKeyword.trim()) {
  //     setError('Both product type and search keyword are required.');
  //     return;
  //   }

  //   try {
  //     const response = await fetch('http://localhost:3000/searchfilter', {
  //       method: 'POST',
  //       headers: { 'Content-Type': 'application/json' },
  //       body: JSON.stringify({ type: productType, productName: searchKeyword }),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Error: ${response.statusText}`);
  //     }

  //     const results = await response.json();
  //     setSearchResults(results);
  //     setShowModal(true);
  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  const handleSearch = async (e) => {
    e.preventDefault();
    setError("");
    setSearchResults([]);

    if (!productType || !searchKeyword.trim()) {
      setError("Both product type and search keyword are required.");
      setShowModal(true);
      return;
    }

    try {
      const response = await Axios.post("/searchfilter", {
        type: productType,
        productName: searchKeyword,
      });

      setSearchResults(response.data);
      setShowModal(true);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      setShowModal(true);
    }
  };

  const LoginData = () => {
    const userInfoString = sessionStorage.getItem("userInfo");
    if (userInfoString) {
      const parsed = JSON.parse(userInfoString);
      setUserInfo(parsed);
    } else {
      console.log("No user info found in session storage.");
    }
  };

  const handleLogout = (event) => {
    event.preventDefault();

    // Show confirmation dialog before proceeding with logout
    setConfirmMessage("Are you sure you want to log out?");
    setConfirmAction(() => () => {
      sessionStorage.removeItem("userInfo");
      navigate("/");
      window.location.reload();
    });
    setConfirmModal(true);
  };

  const handleProductClick = (product) => {
    const type = product.productType?.[0]; // optional chaining + default to first type

    if (product.productType?.includes("Engineering")) {
      navigate(`/engineering/product/single/${product._id}`);
    } else if (product.productType?.includes("Auto-Spare")) {
      navigate(`/singleproduct/${product._id}`);
    } else if (product.productType?.includes("Building")) {
      navigate(`/others/product/single/${product._id}`);
    } else {
      navigate(`/rental/product/single/${product._id}`);
    }
  };

  const handleExcelUpload = async () => {
    if (!selectedFile) return;

    setUploadLoading(true);
    setUploadError(null);
    setUploadResponse(null);

    const formData = new FormData();
    formData.append("file", selectedFile);

    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    formData.append("customerName", userInfo.username);
    formData.append("customerId", userInfo.customerId);
    formData.append("businessType", sessionStorage.getItem("businessType"));

    try {
      const response = await Axios.post("/upload-excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      setUploadResponse(response.data.results);
      setExcelModalOpen(false);
      toast.success("Your order has been placed successfully!");
      console.log("Upload Success:", response.data);
    } catch (err) {
      console.error("Upload Error:", err);
      setUploadError("Upload failed. Please try again.");
    } finally {
      setUploadLoading(false);
    }
  };

  const closeNavbar = () => {
    const nav = document.getElementById("navbarNavDropdown");
    if (nav && nav.classList.contains("show")) {
      // Bootstrap collapse trigger
      document.querySelector(".navbar-toggler")?.click();
    }
  };
  return (
    <>
      <nav className="tnav-wrapper">
        <div className="tnav-mobile">
          <img
            src={"/images/logo.svg"}
            alt="Logo"
            className="tnav-mobile-logo"
          />

          <button
            className="tnav-mobile-menu-btn"
            onClick={() => setOpenMenu(!openMenu)}
          >
            {openMenu ? <FaTimes size={22} /> : <FaBars size={22} />}
          </button>
        </div>

        {openMenu && (
          <div className="tnav-mobile-dropdown">
            <ul>
              <li>
                {" "}
                <Link
                  className="Nav-link nav-home"
                  to="/"
                  onClick={closeNavbar}
                >
                  Home
                </Link>
              </li>
              <li>
                <Link className="Nav-link" to="/about" onClick={closeNavbar}>
                  About us
                </Link>
              </li>
              <li>
                <Link
                  className="Nav-link"
                  to="/whole-products"
                  onClick={closeNavbar}
                >
                  Products
                </Link>
              </li>
              {userInfo && (
                <li>
                  <Link
                    className="Nav-link"
                    to="/account"
                    onClick={closeNavbar}
                  >
                    My Account
                  </Link>
                </li>
              )}
              <li>
                <Link className="Nav-link" to="/review" onClick={closeNavbar}>
                  Customer reviews
                </Link>
              </li>
              <li>
                <Link className="Nav-link" to="/contact" onClick={closeNavbar}>
                  Contact Us
                </Link>
              </li>
            </ul>
            <div
              className="Select-types font-select"
              style={{ marginBottom: "15px" }}
            >
              <select
                className="form-control form-select-type"
                value={productType}
                onChange={(e) => {
                  const selectedType = e.target.value;
                  const routeMap = {
                    Engineering: "/engineering-home",
                    Building: "/others-home",
                    "Auto-Spare": "/",
                  };
                  if (selectedType) {
                    closeNavbar();
                    setConfirmMessage(
                      `Are you sure you want to switch to the ${selectedType} page?`
                    );
                    setConfirmAction(() => () => {
                      setProductType(selectedType);
                      sessionStorage.setItem("businessType", selectedType);
                      navigate(routeMap[selectedType] || "/");
                    });
                    setConfirmModal(true);
                  }
                }}
              >
                <option value="">Select Type</option>
                <option value="Auto-Spare">Auto-Spare</option>
                <option value="Engineering">Engineering</option>
                <option value="Building">Building</option>
                <option value="Rental">Rental</option>
              </select>
            </div>
            <div className="tnav-mobile-buttons">
              <Link className="tnav-signup" to="/signup" onClick={closeNavbar}>
                Signup
              </Link>
              <Link className="tnav-login" to="/login" onClick={closeNavbar}>
                Login
              </Link>
            </div>
          </div>
        )}

        <div className="tnav-container">
          <ul className="tnav-menu">
            <li>
              {" "}
              <Link className="Nav-link nav-home" to="/" onClick={closeNavbar}>
                Home
              </Link>
            </li>
            <li>
              <Link className="Nav-link" to="/about" onClick={closeNavbar}>
                About us
              </Link>
            </li>
            <li>
              <Link
                className="Nav-link"
                to="/whole-products"
                onClick={closeNavbar}
              >
                Products
              </Link>
            </li>
            {userInfo && (
              <li>
                <Link className="Nav-link" to="/account" onClick={closeNavbar}>
                  My Account
                </Link>
              </li>
            )}
            <li>
              <Link className="Nav-link" to="/review" onClick={closeNavbar}>
                Customer reviews
              </Link>
            </li>
            <li>
              <Link className="Nav-link" to="/contact" onClick={closeNavbar}>
                Contact Us
              </Link>
            </li>
          </ul>

          <div className="form-inline phone-link font-phone">
            <img src={"/images/help.svg"} alt="Help" />
            +973 123456 7986
          </div>

          <div
            className="Select-types font-select"
            style={{ position: "relative", display: "inline-block" }}
          >
            <select
              className="form-control form-select-type"
              value={productType}
              onChange={(e) => {
                const selectedType = e.target.value;
                const routeMap = {
                  Engineering: "/engineering-home",
                  Building: "/others-home",
                  "Auto-Spare": "/",
                };
                if (selectedType) {
                  closeNavbar();
                  setConfirmMessage(
                    `Are you sure you want to switch to the ${selectedType} page?`
                  );
                  setConfirmAction(() => () => {
                    setProductType(selectedType);
                    sessionStorage.setItem("businessType", selectedType);
                    navigate(routeMap[selectedType] || "/");
                  });
                  setConfirmModal(true);
                }
              }}
              style={{ paddingRight: "30px" }}
            >
              <option value="">Select Type</option>
              <option value="Auto-Spare">Auto-Spare</option>
              <option value="Engineering">Engineering</option>
              <option value="Building">Building</option>
              <option value="Rental">Rental</option>
            </select>
            <FaChevronDown
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
                color: "#666",
              }}
            />
          </div>

          {/* BUTTONS */}
          <div className="tnav-buttons">
            {userInfo ? (
              <button
                className="tnav-logout"
                onClick={handleLogout}
                style={{ textDecoration: "none" }}
              >
                Logout
              </button>
            ) : (
              <>
                <Link
                  className="tnav-signup"
                  to="/signup"
                  onClick={closeNavbar}
                  style={{ textDecoration: "none" }}
                >
                  Signup
                </Link>
                <Link
                  className="tnav-login"
                  to="/login"
                  onClick={closeNavbar}
                  style={{ textDecoration: "none" }}
                >
                  Login
                </Link>
              </>
            )}
          </div>
        </div>
      </nav>
      <Modal
        show={confirmModal}
        onHide={() => setConfirmModal(false)}
        backdrop="static"
        keyboard={false}
        centered
      >
        {/* <Modal.Header closeButton>
              <Modal.Title>&nbsp;</Modal.Title>
            </Modal.Header> */}
        <Modal.Body className="px-4 py-5 text-center">
          <i
            className="fa fa-exclamation-triangle"
            style={{ fontSize: "80px", color: "#DA354E" }}
          ></i>
          <br />
          <b>{confirmMessage}</b>
        </Modal.Body>

        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setConfirmModal(false)}
            style={{ backgroundColor: "#DA354E" }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            style={{ backgroundColor: "#1A54A5" }}
            onClick={() => {
              setConfirmModal(false);
              confirmAction && confirmAction();
            }}
          >
            Confirm
          </Button>
          {/* <Button
                variant="secondary"
                onClick={() => setConfirmModal(false)}
                style={{ backgroundColor: "#DA354E" }}
              >
                Cancel
              </Button> */}
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TopNavBar;
